import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';

import { RBAC_PERMISSIONS_FEATURE_KEY, rbacPermissionsReducer } from './rbac-permissions.reducer';
import { RbacPermissionsEffects } from './rbac-permissions.effects';
import { RbacPermissionsFacade } from './rbac-permissions.facade';

@NgModule({
    declarations: [],
    imports: [
        StoreModule.forFeature(RBAC_PERMISSIONS_FEATURE_KEY, rbacPermissionsReducer),
        EffectsModule.forFeature([RbacPermissionsEffects]),
    ],
    providers: [RbacPermissionsFacade],
})
export class RbacPermissionsStoreModule {}
